import { Grid } from '@mui/material';

import { ContainerColumnLeft } from '@occc-app/design-system';
import { Offer_Activation_Operator } from '@occc/graphql';
import { CardLayout, InfoField } from '@occc/ui-design-system';

import { OfferActivation } from '../../types';

type OfferActivationsProps = {
  offerActivations: OfferActivation[];
};

export const OfferActivations = ({ offerActivations }: OfferActivationsProps) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Offer Activation'>
        {offerActivations.map(({ activationOperator, targetOffer }, index) => {
          return (
            <Grid container spacing={3} key={index}>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Activation'
                  value={
                    activationOperator === Offer_Activation_Operator.IsActivated
                      ? 'Has activated'
                      : 'Has not activated'
                  }
                  noDataMessage='Is not specified'
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Target Offer Name'
                  value={targetOffer?.name}
                  noDataMessage='Is not specified'
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Target Offer Id'
                  value={targetOffer?.id}
                  noDataMessage='Is not specified'
                />
              </Grid>
            </Grid>
          );
        })}
      </CardLayout>
    </ContainerColumnLeft>
  );
};
